import React from "react";
const galleryIcon = require("../styles/images/gallery2.svg");
const folderIcon = require("../styles/images/folder2.svg");
const shortcutIcon = require("../styles/images/icon-add-shortcut.svg");

interface CreateDropdownMenuProps {
  onGalleryClick: () => void;
  onFolderClick: () => void;
  className?: string;
  style?: React.CSSProperties;
  canCreateEvents?: boolean;
  canCreateFolders?: boolean;
}

const CreateDropdownMenu: React.FC<CreateDropdownMenuProps> = ({
  onGalleryClick,
  onFolderClick,
  className = "dropdown-menu ws-dropdown-menu ws-dropdown-menu-create",
  style = { display: "block" },
  canCreateEvents = true,
  canCreateFolders = true
}) => {
  return (
    <div className={className} style={style}>
      {canCreateEvents && (
        <button
          type="button"
          className="create-action-btn"
          onClick={onGalleryClick}
        >
          <div className="ws-create-icon-container">
            <img
              src={galleryIcon}
              className="ws-create-action-icon"
              alt="gallery-icon"
            />
          </div>
          <span> Event</span>
        </button>
      )}

      {canCreateFolders && (
        <button
          type="button"
          className="create-action-btn"
          onClick={onFolderClick}
        >
          <div className="ws-create-icon-container">
            <img
              src={folderIcon}
              className="ws-create-action-icon"
              alt="folder-icon"
            />
          </div>
          <span>Folder</span>
        </button>
      )}
      {/* 
        RIYA / GOWTHAMI, this commented code adds the "Create shortcut" option, 
        This will be added later on down the line, so I've kept it commented
        Here's the design
        https://www.figma.com/design/BEPqP86pK1WMKvSr2rhLHP/Photo-Manager?node-id=4640-21401&t=8ET1ZZEZDdMk7v2f-0
      */}
      {/* <hr />
      <button
        type="button"
        className="create-action-btn"
        onClick={}
      >
        <div className="ws-create-icon-container">
          <img
            src={shortcutIcon}
            className="ws-create-action-icon"
            alt="folder-icon"
          />
        </div>
        <span>Shortcut</span>
      </button> */}
    </div>
  );
};

export default CreateDropdownMenu;